import React from "react";
import { useParams } from "react-router";
import Fixtures from "./Fixtures";
import { Main, Wrapper } from "./Layout";

const FixturesWrapper: React.FC = () => {
  const { eventId = 0 } = useParams();
  return (
    <Wrapper>
      <Main>
        <Fixtures eventId={Number(eventId)} useLinks />
      </Main>
    </Wrapper>
  );
};

export default FixturesWrapper;
